import React, { useState } from 'react'
import styles from './BillingHistory.module.css'
import InvoiceCard from './InvoiceCard'

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'paid', label: 'Paid' },
  { key: 'unpaid', label: 'Unpaid' },
]

const BillingHistory = ({ invoices = [], onDownload, onInvoiceAction, onUpgrade, payingId, payMessage, payMessageId }) => {
  const [filter, setFilter] = useState('all')

  const visible = invoices.filter((inv) => {
    if (filter === 'all') return true
    return inv.status === filter
  })

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>Billing History</h3>
          <p className={styles.subtitle}>View and manage all your invoices</p>
        </div>
        <button type="button" className={styles.upgradeButton} onClick={onUpgrade}>
          Upgrade plan
        </button>
      </div>

      <div className={styles.filters}>
        {FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            className={`${styles.pill} ${filter === f.key ? styles.pillActive : ''}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className={styles.list}>
        {visible.length === 0 ? (
          <p className={styles.empty}>No invoices here.</p>
        ) : (
          visible.map((inv) => (
            <InvoiceCard
              key={inv.id}
              invoiceNo={inv.id}
              status={inv.status}
              date={inv.date}
              time={inv.time}
              reason={inv.reason}
              minutes={inv.minutes}
              minutesLabel={inv.minutesLabel}
              amount={inv.amount}
              note={inv.note}
              onDownload={() => onDownload?.(inv)}
              onPrimary={() => onInvoiceAction?.(inv)}
              busy={!!payingId && payingId === inv.stripeInvoiceId}
              message={payMessageId === inv.stripeInvoiceId ? payMessage : undefined}
            />
          ))
        )}
      </div>
    </section>
  )
}

export default BillingHistory
